export default {"src":"/_next/static/media/ic_add_cash.d482e153.svg","height":23,"width":23,"blurWidth":0,"blurHeight":0};